import { useTranslation } from 'react-i18next';
import { ButtonType, SampleDto } from '@src/types/types';
import { Button } from '@components/atoms/Button';
import { IconType } from '@src/types/IconType.ts';
import { classNames } from '@utils/classNames.ts';

export type BackgroundColor = 'white' | 'grey';

export default function ShipmentButtons({
  sample,
  background = 'white',
}: {
  sample: SampleDto;
  background?: BackgroundColor;
}) {
  const { t } = useTranslation('component', {
    keyPrefix: 'shipmentInstructions',
  });

  const backgroundClass =
    background === 'white' ? 'bg-background' : 'bg-grey3light';

  return (
    <div
      className={classNames(
        'flex flex-col w-full gap-2 rounded-bonusLarge  px-4 py-5',
        backgroundClass,
      )}
    >
      <h3 className="font-bold text-[#888] uppercase font-sans text-xs tracking-[0.08em]">
        {t('shipmentLabelTitle')}
      </h3>
      <div className="flex flex-col md:flex-row flex-wrap gap-4 w-full">
        <Button
          label={t('downloadLabel')}
          disabled={!sample.shippingLabeURL}
          buttonType={ButtonType.PRIMARY}
          IconLeading={IconType.Download}
          onClick={() => {
            window.open(sample.shippingLabeURL!);
          }}
          className="max-w-full"
        />
        <Button
          label={t('saveQrCode')}
          disabled={!sample.qrCodeURL}
          buttonType={ButtonType.WHITE}
          IconLeading={IconType.QRCode}
          onClick={() => {
            window.open(sample.qrCodeURL!);
          }}
          className="max-w-full"
        />
      </div>
      <p className="text-sm text-[#555] italic">{t('shipmentLabelHint')}</p>
    </div>
  );
}
